module.exports = __webpack_public_path__ + "img/client-dashboard.f2a30dc6.png";